// extracted by mini-css-extract-plugin
module.exports = {"InvitedPage":"InvitedPage_InvitedPage__mF3Y1","main":"InvitedPage_main__2Ycal"};